<div class="flex flex-col bg-linear-to-b from-surface-100 to-surface-0 dark:from-surface-950 dark:to-surface-900">
	<div class="bg-surface-0 dark:bg-surface-950 shadow-xl w-full h-20 z-20"></div>
	<div
		class="flex flex-col lg:flex-row justify-between px-6 md:px-12 lg:px-20 py-16 gap-16 w-full overflow-hidden -mt-3 z-10 relative">
		<div class="flex flex-col gap-4">
			<app-logo></app-logo>
			<div class="text-sm text-surface-700 dark:text-surface-300 leading-normal">
				10312 Baseline Road <br />Little Rock, Arkansas 72209-8807
			</div>
			<app-call-us-button bgColor="light" size="small"></app-call-us-button>

		</div>
		<div class="grid grid-cols-2 gap-8 w-full max-w-4xl">
			<div class="flex flex-col gap-4">
				<div class="text-base font-medium text-surface-900 dark:text-surface-0 leading-normal">Company</div>
				@for (item of companyItems; track item.label) {
				<a
					class="text-surface-800 font-normal leading-normal hover:text-surface-700 dark:hover:text-surface-200 cursor-pointer"
					[routerLink]="[item.to]">
					{{ item.label }}
				</a>
				}
			</div>
			<div class="flex flex-col gap-4">
				<div class="text-base font-medium text-surface-900 dark:text-surface-0 leading-normal">Legal</div>
				@for (item of legalItems; track item.label) {
				<a
					class="text-surface-800 font-normal leading-normal hover:text-surface-700 dark:hover:text-surface-200 cursor-pointer"
					taget="_blank"
					href="{{item.to}}">
					{{ item.label }}
				</a>
				}
				<a
					id="ot-skd-btn"
					class="optanon-toggle-display ot-sdk-show-settings text-surface-800 font-normal leading-normal hover:text-surface-700 dark:hover:text-surface-200 cursor-pointer"
					>Manage Cookie Preferences</a
				>
			</div>
		</div>
	</div>
	<div
		class="py-6 px-6 md:px-12 lg:px-20 flex flex-wrap items-center justify-between bg-primary-800 w-full border-t border-surface-200 dark:border-surface-700 gap-4">
		<span class="text-base text-surface-0 dark:text-surface-0 font-normal leading-normal"
			>&copy; {{currentYear}} Radius Auto</span
		>

		<!-- <div class="flex items-center gap-8">
			<a class="cursor-pointer text-surface-0 dark:text-surface-0 hover:opacity-75">
				<i class="pi pi-instagram text-base! leading-normal!"></i>
			</a>
			<a class="cursor-pointer text-surface-0 dark:text-surface-0 hover:opacity-75">
				<i class="pi pi-facebook text-base! leading-normal!"></i>
			</a>
		</div> -->
	</div>
</div>
